import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ClientImg1 from "../Assets/img/testimonial/testimonial-1.png";
import ClientImg2 from "../Assets/img/testimonial/testimonial-2.jpg";
import TestimonialImg from "../Assets/img/testimonial/testimonial-img.svg";

const TestimonialMain = [
  {
    id: "item1",
    img: ClientImg1,
    name: "Badruzzaman Azad",
    degignation: "Empowering Net, Chattogram",
    comment:
      "It's my pleasure to be an user of this software. It helps me to get all information of my business in one click. It makes more easier to control our valuable client's support. ",
    // ratting1: "fa fa-star",
    // ratting2: "fa fa-star",
    // ratting3: "fa fa-star",
    // ratting4: "fa fa-star",
    // ratting5: "fa fa-star",
  },
  {
    id: "item2",
    img: ClientImg2,
    name: " Sirazus Salakin",
    degignation: "Computer Mate, Meherpur",
    comment:
      "ISP Digital is saving our precious time. The work that used to be done all day is now being done very fast. ISP Digital has made our life easier than before. Now I can devote more time to other work.",
    // ratting1: "fa fa-star",
    // ratting2: "fa fa-star",
    // ratting3: "fa fa-star",
    // ratting4: "fa fa-star",
  },
  {
    id: "item3",
    img: ClientImg1,
    name: "Badruzzaman Azad",
    degignation: "Empowering Net, Chattogram",
    comment:
      "It's my pleasure to be an user of this software. It helps me to get all information of my business in one click. It makes more easier to control our valuable client's support. ",
    // ratting1: "fa fa-star",
    // ratting2: "fa fa-star",
    // ratting3: "fa fa-star",
    // ratting4: "fa fa-star",
    // ratting5: "fa fa-star",
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    fade: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 2,
    vertical: true,
    verticalSwiping: true,
    beforeChange: function (currentSlide, nextSlide) {
      console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      console.log("after change", currentSlide);
    },
  };
  return (
    <>
      <div className="testimonial-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Clients Testimonial</h3>
                {/* <p>
                  Semper suscipit ornare egestas augue. Ut est etiam mauris at
                  lorem faucibus lorem arcu. Tellus sed gravida pharetra nulla.
                </p> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="testimonial-image">
                <img src={TestimonialImg} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="testimonial-slider">
                <Slider {...settings}>
                  {TestimonialMain.map((SingleSlider) => (
                    <div className="single-slider" key={SingleSlider.id}>
                      <div className="single-testimonial">
                        <div className="testimonial-head">
                          <img src={SingleSlider.img} alt="#" />
                          <div className="testimonial-top-content">
                            <h5>{SingleSlider.name}</h5>
                            <p>{SingleSlider.degignation}</p>
                            {/* <ul className="ratting">
                              <li>
                                <i className={SingleSlider.ratting1}></i>
                              </li>
                              <li>
                                <i className={SingleSlider.ratting2}></i>
                              </li>
                              <li>
                                <i className={SingleSlider.ratting3}></i>
                              </li>
                              <li>
                                <i className={SingleSlider.ratting4}></i>
                              </li>
                              <li>
                                <i className={SingleSlider.ratting5}></i>
                              </li>
                            </ul> */}
                          </div>
                        </div>
                        <div className="testimonial-bottom-content">
                          <i className="fa fa-quote-left"></i>
                          <p>{SingleSlider.comment}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialSlider;
